import SystemLog from '../SystemLog';

export default class Effect {
    constructor(prop, value) {
        this.prop = prop;
        this.value = value;
    }
}


// WEBPACK FOOTER //
// ./engine/Effects/Effect.js